import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { getAdminSku, createAdminSku, editAdminSku, importAdminSku } from "actions/adminSkuAction";
import { formatterCreateAt, FormatterStatus } from "components/Function";
import { ReactTable } from "components/Table";
import Loading from "components/Loading";
import { getSizePerPageList } from "helper/constant";
import SkuForm from "./form";
import InputFile from "components/elements/inputFile";

function AdminSku(props) {
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(50);
    const [filter, setFilter] = useState({});
    const [totalSize, setTotalSize] = useState(0);
    const [list, setList] = useState([]);
    const [isLoading, setIsLoading] = useState(0);
    const [openAdd, setOpenAdd] = useState(false);
    const [itemEdit, setItemEdit] = useState(null);
    var { getAdminSku, createAdminSku, editAdminSku, importAdminSku, formatterCreateAt } = props;

    useEffect(() => {
        setIsLoading(true);
        getAdminSku({ page, sizeperpage: sizePerPage, filter }).then((data) => {
            setIsLoading(false);
            setList(data?.sku || []);
            console.log(data)
            setTotalSize(data?.totalSize || 0);
        });
    }, [getAdminSku, page, sizePerPage, filter]);

    const columns = [
        {
            dataField: "_id",
            text: "",
            sort: true,
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "name",
            text: "Name",
            sort: true,
        },
        {
            dataField: "sku",
            text: "Sku",
            sort: true,
        },
        {
            dataField: "base_cost",
            text: "Base Cost",
            sort: true,
        },
        {
            dataField: "handling_fee",
            text: "Handling Fee",
            sort: true,
        },
        {
            dataField: "shipping_fee",
            text: "Shipping Fee",
            sort: true,
        },
        {
            dataField: "label_fee",
            text: "Label Fee",
            sort: true,
        },
        {
            dataField: "created_at",
            text: "Created At",
            sort: true,
            formatter: (cell, row) => formatterCreateAt(cell),
        },
        {
            dataField: "-",
            text: "Actions",
            formatter: (cell, row, rowIndex, formatExtraData) => (
                <Fragment>
                    <button
                        onClick={() => {
                            setItemEdit(row);
                        }}
                        className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={"Edit"}
                    >
                        <i className="ki-outline ki-notepad-edit fs-2"></i>
                    </button>
                </Fragment>
            ),
        },
    ];

    const groupButton = () => {
        return (
            <div className="d-flex gap-2">
                <button className="btn btn-primary" onClick={() => setOpenAdd(true)}>
                    Create Sku
                </button>
                <div>
                    <InputFile
                        multiple={false}
                        onChange={handleImport}
                    >
                        <button
                            className="btn btn-primary"
                            data-bs-toggle="modal"
                            data-bs-target="#kt_modal_create_app"
                            id="kt_toolbar_primary_button"
                        >
                            <i className="ki-outline ki-cloud-download"></i>
                            Import Sku
                        </button>
                    </InputFile>
                </div>
            </div>
        );
    };

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(50);
            setFilter((prev) => ({ ...prev, search: searchText }));
        } else {
            setPage(page || 1);
            setSizePerPage(sizePerPage);
        }
    };

    const reloadList = () => {
        return getAdminSku({ page, sizeperpage: sizePerPage, filter }).then((data) => {
            setList(data.sku);
            setTotalSize(data?.totalSize || 0);
        });
    };

    const handleCreate = async (data) => {
        setIsLoading(true);
        await createAdminSku(data);
        await reloadList();
        setIsLoading(false);
        setOpenAdd(false);
    };

    const handleEdit = async (data) => {
        setIsLoading(true);
        await editAdminSku(data);
        await reloadList();
        setIsLoading(false);
        setItemEdit(null);
    };

    const handleImport = async (e) => {
        const files = Object.values(e);
        setIsLoading(true);
        if (files.length) await importAdminSku(Object.values(e));
        await reloadList();
        setIsLoading(false);
    }

    return (
        <Fragment>
            <Loading isLoading={isLoading} />
            <div className="card mb-5 mb-xl-10">
                <div className="card-body p-9">
                    <div className="al-variants-table">
                        <ReactTable
                            columns={columns}
                            data={list}
                            groupButton={groupButton}
                            handleTableChange={handleTableChange}
                            page={page}
                            sizePerPage={sizePerPage}
                            totalSize={totalSize}
                            alClassName="table-layout-inherit"
                            sizePerPageList={getSizePerPageList(totalSize)}
                        />
                        <SkuForm
                            isOpen={openAdd}
                            onClose={() => setOpenAdd(false)}
                            title="Create Sku"
                            onSubmit={handleCreate}
                        />
                        <SkuForm
                            isOpen={Boolean(itemEdit)}
                            onClose={() => setItemEdit(null)}
                            formData={itemEdit}
                            title="Edit Sku"
                            onSubmit={handleEdit}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    formatterCreateAt,
    FormatterStatus,
    getAdminSku,
    createAdminSku,
    editAdminSku,
    importAdminSku,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminSku);
